// extracted by mini-css-extract-plugin
module.exports = {"summary":"CommendationAccordion_summary__1ukOF","list":"CommendationAccordion_list__6RifM","icon":"CommendationAccordion_icon__2Jj5y"};